<template>
    <v-layout align-start>
        <v-flex>
             <v-data-table
                :headers="headers"
                :items="notificaciones"
                :search="search"
                class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat color="white">
                <v-toolbar-title>Notificaciones</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Busqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer>


                <v-dialog v-model="dialognot" max-width="290">
                    <v-card>
                        <v-card-title class="headline">Notificaciones push</v-card-title>
                        <v-card-text>
                        Una vez que acepte el envio, el mensaje llegara via notificacion push al dispositivo movil de todos los usuarios pertenecientes al grupo seleccionado
                        </v-card-text>

                        <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                            color="green darken-1"
                            text
                            @click="dialognot = false"
                        >
                            Cancelar
                        </v-btn>

                        <v-btn
                            color="green darken-1"
                            text
                            @click="enviar()"
                        >
                            Aceptar
                        </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
        
              <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on" outlined>Crear nueva notificacion</v-btn>
                    </template>
                    <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title><span class="headline"></span></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items> 
                            <v-btn dark text @click="crear">Grabar</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-list three-line subheader>
                        <v-container fluid>
                            <span>Crear notificación</span>
                            <v-row>
                              <v-col class="d-flex" cols="12" sm="6">
                                    <v-select
                                    :items="grupos"
                                    label="Selecciona grupo"
                                    item-text="nombre"
                                    item-value="idGrupo"
                                    v-model="select"
                                    outlined
                                    return-object
                                    single-line
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        label="Titulo"
                                        v-model="editrow.titulo"
                                        outlined>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <v-textarea
                                        outlined
                                        name="Mensaje"
                                        label="Mensaje"
                                        v-model="editrow.mensaje"
                                        value="">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list three-line subheader>
                        </v-list>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
          
            </template> 
            <template v-slot:body="{ items }">
                <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                        <td>
                           <div>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                         <v-icon small class="mr-2" @click="modificar(item)">
                                        edit 
                                    </v-icon>
                                    </v-btn>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                              <v-tooltip  top>
                                    <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                       <v-icon small class="mr-2" @click="eliminar(item)">
                                        delete
                                         </v-icon>
                                    </v-btn>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>  
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon small @click="abrirconfirmacion(item)">
                                        send
                                     </v-icon>
                                    </v-btn>
                                    </template>
                                    <span>Enviar</span>
                                </v-tooltip>
                            </div>
                        </td>
                        <td>{{ item.grupo }}</td>
                        <td>{{ item.titulo }}</td>
                        <td>{{ item.mensaje }}</td>
                        <td>{{ item.fecha }}</td>
                    </tr>
                </tbody>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Resetear</v-btn>
            </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>  

<script>
import axios from 'axios'
import moment from 'moment'

export default {
   created () {
        this.listar(),
        this.getGrupo()
    },
    data() {
        return {
            notificaciones:[],
            menssagesend: {},
            editrow: {},
            grupos:[],
            dialog: false,
            dialognot: false,
            headers: [
                { text: 'Opciones', value: 'opciones', sortable: false },
                { text: 'Grupo', value: 'grupo' },
                { text: 'Titulo', value: 'titulo' },
                { text: 'Mensaje', value: 'mensaje' },
                { text: 'Fecha', value: 'fecha' },
            ],
            newNotificacion: {
                titulo: '',
                mensaje: ''
            },
            textoAct: '',
            search: '',
            snackbar: false,
            snackbarcolor: '',
            titulo: '',
            mensaje: '',
            select: { },
            idgrupo: '',
            grupo: '',
            fecha: new Date().toISOString().substr(0, 10),
        }
    },
    computed: {
        formTitle () {
        return this.editedIndex === -1 ? 'Crear Comunicado' : 'Actualizar Comunicado'
        },
    },
    watch: {
        dialog (val) {
        val || this.close()
        },
    },
    
    methods: {
        listar(){
            let context =this;
            context.$store.dispatch('setIsBusy', true)
            axios.get('api/notificacion/Get').then(function(response){
                context.notificaciones = response.data.datos;
               context.$store.dispatch('setIsBusy', false)
            }).catch(function(error){
                    console.log(console.error());
            });
         
        },
        getGrupo()
        { 
            let context =this;
            axios.get('api/Grupos/Get').then(function(response){
                if(response.data.exito){
                    context.grupos = response.data.datos;
                     context.new()
                }
               
            }).catch(function(error){
                    console.log(console.error());
            });
        },
        formatDate (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        crear ()
        {
            let ctx = this;
            debugger  

            if( ctx.editrow.idNotificacion == undefined)
                  ctx.editrow.idNotificacion = 0;

                 var json = { 
                    "IdNotificacion" : ctx.editrow.idNotificacion,
                    "IdGrupo" : ctx.select.idGrupo,
                    "Titulo": ctx.editrow.titulo,
                    "Mensaje": ctx.editrow.mensaje,
                    // "Fecha": ctx.editrow.Fecha
                }; 
                debugger;
                axios.post('api/Notificacion/Guardar', json )
                .then(function(response){
                        ctx.listar();
                        ctx.snackbar = true;
                        ctx.snackbarcolor = 'teal darken-4';
                    }).catch(function(error){
                    console.log(console.error());
                });
           
            this.close();
        },
        modificar (item) {
            this.editrow = item
            var selectgrupo = this.grupos.find(s => s.idGrupo == item.idGrupo)
            this.select = selectgrupo
            // this.select = this.
            // this.select.idGrupo  = this.editrow.idGrupo
            // this.select.nombre = this.editrow.grupo
            this.dialog = true
        },
        eliminar (item) {
            let ctx = this
            debugger
            ctx.$axios.get('api/notificacion/Eliminar?IdNotificacion=' + item.idNotificacion)
                .then(res => {
                    if(res.data.exito) {
                        ctx.listar();
                        console.log("Registro eliminado")
                    }
                })
                .catch(e => { console.log(e) })
         },
         abrirconfirmacion(item) {
             this.dialognot = true
             this.menssagesend = item
         },
        enviar() {
            let ctx = this
            debugger
             var json = { 
                    "title" : ctx.menssagesend.titulo,
                    "body" : ctx.menssagesend.mensaje,
                    "IdGrupo":ctx.menssagesend.idGrupo
                }; 
                debugger;
                axios.post('api/notificacion/SendNotification', json )
                .then(function(response){
                        ctx.listar();
                        ctx.snackbar = true;
                        ctx.snackbarcolor = 'teal darken-4';
                        ctx.$root.Mensaje(response.data.message)
                    }).catch(function(error){
                    console.log(console.error());
                });
             this.dialognot = false
         },
        close() {
            this.dialog = false;
            setTimeout(() => {
               this.editedItem = Object.assign({}, this.defaultItem) 
               this.editedIndex = -1;
            }, 300);
        },
        vsuccess(file, response) {
            debugger;
            this.success = true
            this.editedItem.path = file.name;
        },
    }
}
</script>